<template>
  <!-- padding-bottom: 10px; 为底部 留有空位 -->
  <div class="home-container" :style="homeContainStyle">
    <RegisterCard ref="registerCard" />
    <div v-if="userPlatform === 2" class="home-banner"></div>
    <div v-if="userPlatform !== 2" class="sm-home-banner"></div>
    <div class="carousel-container">
      <div
        class="carousel-box"
        id="head-carousel-container"
        @click="toRegister"
        v-if="zhishuList.length > zhishuShowLength"
      >
        <div
          v-for="(item, index) in zhishuList"
          :key="index"
          :class="['carousel-item', carouselItemShow(index)]"
          :style="carouselItemStyle(index)"
        >
          <div class="carousel-item-head">
            <div>{{ item.productName }}</div>
            <div class="carousel-sub-title">{{ item.priceDate }}</div>
          </div>
          <div class="carousel-item-content">
            <span class="main" :style="{ color: itemTextColor(item) }">
              {{ item.price }}
            </span>

            <div class="aside" :style="{ background: itemBgColor(item) }">
              <img
                v-if="arrDownShow(item.changePriceShow)"
                class="img-icon"
                src="../assets/home/arrow-down-white.png"
                alt=""
              />
              <img
                v-if="arrUpShow(item.changePriceShow)"
                class="img-icon"
                src="../assets/home/arrow-up-white.png"
                alt=""
              />
              {{ headDoubleNum(item["changePriceShow"]) }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="carousel-box"
        id="head-carousel-container"
        @click="toRegister"
        v-if="zhishuList.length <= zhishuShowLength"
      >
          <div
            v-for="(item, index) in zhishuList"
            :key="index"
            :class="['carousel-item carousel-normal-item']"
            :style="{ left: 190 * index + 'px' }"
          >
            <div class="carousel-item-head">
              <div>{{ item.productName }}</div>
              <div class="carousel-sub-title">{{ item.priceDate }}</div>
            </div>
            <div class="carousel-item-content">
              <span class="main" :style="{ color: itemTextColor(item) }">
                {{ item.price }}
              </span>

              <div class="aside" :style="{ background: itemBgColor(item) }">
                <img
                  v-if="arrDownShow(item.changePriceShow)"
                  class="img-icon"
                  src="../assets/home/arrow-down-white.png"
                  alt=""
                />
                <img
                  v-if="arrUpShow(item.changePriceShow)"
                  class="img-icon"
                  src="../assets/home/arrow-up-white.png"
                  alt=""
                />
                {{ headDoubleNum(item["changePriceShow"]) }}
              </div>
            </div>
          </div>
      </div>



    </div>

    <div class="card-module-container" style="margin-top: 20px">
      <home-normal-card
        @click.native="toRegister"
        :list="categoryModuleList_1['list']"
        :moduleTitle="moduleNameShow(categoryModuleList_1['name'])"
      />
      <home-normal-card
        @click.native="toRegister"
        :list="categoryModuleList_2['list']"
        :moduleTitle="moduleNameShow(categoryModuleList_2['name'])"
      />
        <home-normal-card
          @click.native="toRegister"
          :list="categoryModuleList_3['list']"
          :moduleTitle="moduleNameShow(categoryModuleList_3['name'])"
        />
    </div>
    <div class="card-module-container">
      <div class="card-thrid-item card-module-normal">
        <div class="card-item-head">百川盈孚视点</div>
        <div class="card-head-line"></div>
        <ViewPointTable :viewPointList="viewPointList" @toRegister="toRegister" />
      </div>
        <div class="card-thrid-item card-module-right">
          <div class="card-item-head">
            商品价格涨跌
            <span class="card-item-head-sub"> {{ priceShowDate }} </span>
          </div>
          <div class="card-head-line"></div>

          <div class="card-box" @click="toRegister">
            <div class="box-head">
              <div
                v-for="item in priceHeadList"
                :key="item.key"
                class="box-head-item"
              >
                {{ item.title }}
              </div>
            </div>
            <PriceTable
              :headInfoList="headInfoList"
              :priceHeadList="priceHeadList"
            />
          </div>
        </div>
      <div class="card-thrid-item card-module-normal">
        <div class="card-item-head">大宗商品关注异动指数</div>
        <div class="card-head-line"></div>
        <bar-chart @click.native="toRegister" />
      </div>
    </div>

    <HomeReport
      :weekReportList="weekReportList"
      :monthReportList="monthReportList"
      :yearReportList="yearReportList"
      @toRegister="toRegister"
    />
    <div class="main-container advitise-container" @click="toRegister">
      <img src="../assets/home/adv-1.png" alt="" />
      <img src="../assets/home/adv-2.png" alt="" />
      <img src="../assets/home/adv-3.png" alt="" />
    </div>
    <goods-module v-if="userPlatform === 2" />
    <HomeAboutUs />
    <BiBottom :isShow="!isMobileDevice" />
    <tip-card v-if="userPlatform === 2" @click="toRegister" />
    <!-- 底部拨打电话 -->
    <div
      v-if="userPlatform !== 2"
      class="home-contain-bottom"
      :style="homeContainBS"
    >
      <div class="contain-bottom-item">
        <a href="tel:18618300427"> 拨打电话 </a>
      </div>
      <div
        class="contain-bottom-item contain-bottom-bg-item"
        @click="toRegister"
      >
        立即注册会员
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import PriceTable from "@/components/PriceTable.vue";
import BiBottom from "@/components/BiBottom.vue";
import ViewPointTable from "@/components/ViewPointTable.vue";
import HomeAboutUs from "@/components/HomeAboutUs.vue";
import HomeReport from "@/components/HomeReport.vue";
import RegisterCard from "@/components/RegisterCard/index.vue";
import BarChart from "@/components/BarChart.vue";
import { mapState } from "vuex";
import GoodsModule from "@/components/GoodsModule.vue";
import TipCard from "@/components/TipCard.vue";

import HomeNormalCard from "@/components/HomeNormalCard.vue";

import {
  getPriceInfo,
  getZhishu,
  getReportWeek,
  getReportMonth,
  getReportYear,
  getViewpoint,
  getMarketDynamic,
  getDailyCommit,
  // getClassInfo,
  getClassInfo_all,
  getClassInfo_2,
  getClassInfo_3,
} from "@/api/homeinfo.js";

export default {
  name: "home",
  components: {
    GoodsModule,
    BarChart,
    PriceTable,
    BiBottom,
    ViewPointTable,
    HomeAboutUs,
    HomeReport,
    RegisterCard,
    TipCard,
    HomeNormalCard,
  },
  data() {
    return {
      routeQuery: {},
      headSetdoFun: null,
      priceInfoDate: "",

      zhishuShowLength: 7,
      // 指数
      zhishuList: [],

      //价格涨跌
      headInfoList: [],
      // 从 1 开始
      carouselFirIndex: 1,

      priceHeadList: [
        {
          title: "商品",
          key: "productName",
        },
        {
          title: "价格",
          key: "price",
        },
        {
          title: "涨跌额",
          key: "changePriceShow",
        },
        {
          title: "涨跌幅",
          key: "quoteChange",
        },
      ],

      // moduleItem
      // {
      //   Name: "钢铁百川视点",
      //   List:[
      //     {
      //       NLinksID: 5626128,
      //       NewsTitle: '六载风雨路 共创百川梦—2013年百川资讯六周年年会',
      //       AddTime: "/Date(1658822530350)/"
      //     }
      //   ]
      // }
      // categoryModuleList: [],

      categoryModuleList_1: {
        list: [],
        name: ''
      },
      categoryModuleList_2: {
        list: [],
        name: ''
      },
      categoryModuleList_3: {
        list: [],
        name: ''
      },

      // 视点信息
      viewPointList: [],
      // 日评信息
      commitList: [],

      // 市场动态
      dynamicList: [],
      // 年报
      weekReportList: [],
      monthReportList: [],
      yearReportList: [],
    };
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
    }),
    // cateModule() {
    //   const sourceInfo = this.categoryModuleList;
    //   return (num) => {
    //     let defaultModule = {
    //       Name: "百川盈孚数据",
    //       List: [],
    //     };
    //     return sourceInfo[num] ? sourceInfo[num] : defaultModule;
    //   };
    // },
    homeContainBS() {
      if (this.userPlatform === 0) {
        return {
          bottom: "2em",
        };
      }
    },
    homeContainStyle() {
      if (this.userPlatform !== 2) {
        return {
          paddingBottom: "4em",
        };
      }
      return {};
    },
    // 是否为 移动设备
    isMobileDevice() {
      if (this.userPlatform === 1 || this.userPlatform === 0) {
        return true;
      }
      return false;
    },
    carouseShowIndexList() {
      const defaultShowLength = this.zhishuShowLength;
      const resList = [];

      let firDistance = this.carouselFirIndex - 1;
      if (firDistance <= 0) {
        firDistance = firDistance + this.zhishuList.length;
      }
      resList.push(firDistance);

      for (let index = 0; index < defaultShowLength; index++) {
        let distance = this.carouselFirIndex + index;
        if (distance > this.zhishuList.length) {
          distance = distance - this.zhishuList.length;
        }
        if (firDistance <= 0) {
          firDistance = firDistance + this.zhishuList.length;
        }
        resList.push(distance);
      }

      let tailDistance = this.carouselFirIndex + defaultShowLength;
      if (tailDistance > this.zhishuList.length) {
        tailDistance = tailDistance - this.zhishuList.length;
      }
      resList.push(tailDistance);

      return resList;
    },

    headDoubleNum() {
      return (doubleValue) => {
        return parseFloat(doubleValue) > 0 ? "+" + doubleValue : doubleValue;
      };
    },
    headTime() {
      return (timeValue) => {
        let date = new Date(parseInt(timeValue));
        const month = "0" + (date.getMonth() + 1);
        const day = "0" + date.getDate();
        return date.getFullYear() + "." + month.slice(-2) + "." + day.slice(-2);
      };
    },

    carouselItemStyle() {
      const defaultShowLength = this.zhishuShowLength;

      const defaultItemWidth = 190;
      return (index) => {
        let currenIndex = index + 1;
        let findIndex = this.carouseShowIndexList.findIndex(
          (item) => item === currenIndex
        );
        if (findIndex < 0) {
          return {
            left: (defaultShowLength + 1) * defaultItemWidth + "px",
          };
        }
        return {
          left: (findIndex - 1) * defaultItemWidth + "px",
        };
      };
    },
    arrDownShow() {
      return (value) => {
        return parseFloat(value) < 0 ? true : false;
      };
    },
    arrUpShow() {
      return (value) => {
        return parseFloat(value) > 0 ? true : false;
      };
    },

    carouselItemShow() {
      return (index) => {
        let currenIndex = index + 1;
        let findIndex = this.carouseShowIndexList.findIndex(
          (item) => item === currenIndex
        );

        if (findIndex <= 0) {
          return "carousel-hidden-item";
        }
        if (this.zhishuShowLength < this.zhishuList.length && findIndex === this.carouseShowIndexList.length - 1) {
          return "carousel-hidden-item";
        }
        return "carousel-normal-item";
      };
    },
    itemTextColor() {
      return (item) => {
        let quarter = parseFloat(item["changePriceShow"]);
        let colorStr = quarter < 0 ? "#009933" : "#DD2200";
        if (quarter === 0) {
          colorStr = "#666666";
        }
        return colorStr;
      };
    },
    itemBgColor() {
      return (item) => {
        let quarter = parseFloat(item["changePriceShow"]);
        let colorStr = quarter < 0 ? "#009933" : "#DD2200";
        if (quarter === 0) {
          colorStr = "#A0A3A9";
        }
        return colorStr;
      };
    },
    priceShowDate() {
      let date = new Date();
      if (this.priceInfoDate) {
        date = new Date(this.priceInfoDate);
      } else {
        return "  月  日";
      }
      const month = "0" + (date.getMonth() + 1);
      const day = "0" + date.getDate();
      return date.getFullYear() + "." + month.slice(-2) + "." + day.slice(-2);
    },
    moduleNameShow(){
      return (moduleName) => {
        if (!moduleName || moduleName.indexOf(':') === -1) return moduleName
        return moduleName.split(':')[0]
      }
    }
  },
  watch: {
    "$route.query": {

      handler(v, oldv) {
        const {
          categoryId,
          newId1,
          newId2,
          newId3,
          source
        } = v
        if (v !== oldv) {
          this.initCategoryInfo({
            categoryId,
            newId1,
            newId2,
            newId3,
            source
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    this.initRouteQuery();
    this.initPriceInfo();
    this.initViewPointList();

    // this.initCommitInfo();
    // this.initDynamicInfo();

    this.initWeekReport();
    this.initMonthReport();
    this.initYearReport();
  },
  async mounted() {
    await this.initZhishu();

    if (this.zhishuShowLength < this.zhishuList.length) {
      this.headCarouselScroll();
      this.initHandleHeadMouse();
      this.listenWindowsHidden();
    }

    this.removeAllLink();

    // this.listenReload();
  },
  methods: {
    // listenReload() {
    //   let that = this
    //   let query = this.$route.query
    //   window.onload = function () {
    //     if (window.name != "noReload") {
    //       delete query.formType
    //       window.name = "noReload";
    //       sessionStorage.clear();
    //       that.$rotuer.push({
    //         path: '/',
    //         query:{
    //           ...query,
    //         }
    //       })
    //     } else {
    //       window.name = "";
    //     }
    //   };
    // },
    // 获取指定类 数据
    initCategoryInfo({
      categoryId, newId1, newId2, newId3,source
    }) {
      if (!categoryId || !newId1 || !newId2 || !newId3) {
        return;
      }
      getClassInfo_all({
        categoryId,
        newId1,
        newId2,
        newId3,
        source
      }).then(res=>{
        if (res.code === 200) {
          const resData = res.data
          let count = 1
          for (const key in resData) {
            if (Object.hasOwnProperty.call(resData, key)) {
              const element = resData[key];
              this['categoryModuleList_' + count]['list'] = element
              this['categoryModuleList_' + count]['name'] = key
              count++;
            }
          }
        }
      })
      // getClassInfo({
      //   categoryId,
      // })
      //   .then((res) => {
      //     this.categoryModuleList = res;
      //   })
      //   .finally(() => {});
      // getClassInfo_1({
      //   categoryId,
      // })
      //   .then((res) => {
      //     this.categoryModuleList_1 = res[0];
      //   })
      //   .finally(() => {});
      // getClassInfo_2({
      //   categoryId,
      // })
      //   .then((res) => {
      //     this.categoryModuleList_2 = res[0];
      //   })
      //   .finally(() => {});
      // getClassInfo_3({
      //   categoryId,
      // })
      //   .then((res) => {
      //     this.categoryModuleList_3 = res[0];
      //   })
      //   .finally(() => {});

    },

    listenWindowsHidden() {
      let that = this;
      document.addEventListener("visibilitychange", function () {
        let widnStatus = document.visibilityState;
        if (widnStatus === "hidden") {
          that.headCarouselPause();
        } else {
          that.headCarouselScroll();
        }
      });
    },
    removeAllLink() {
      let that = this;
      let idList = ["marketDynamic", "dailyCommit"];
      window.onload = function () {
        for (let index = 0; index < idList.length; index++) {
          const id = idList[index];
          that.removeAlinkAttr(id);
        }
      };
    },
    removeAlinkAttr(eleId) {
      let aContainer = document.getElementById(eleId);
      if (!aContainer) {
        return;
      }
      let alist = aContainer.getElementsByTagName("a");
      for (let index = 0; index < alist.length; index++) {
        const element = alist[index];

        element.removeAttribute("href");
        element.removeAttribute("target");

        // element.setAttribute('data-id',index)
      }
    },
    initRouteQuery() {
      const query = this.$route.query;
      this.routeQuery = query;
    },
    async initZhishu() {
      let res = await getZhishu();
      if(res.code === 200){
        this.zhishuList = res.data;
      }
    },
    initPriceInfo() {
      getPriceInfo().then((res) => {
        if (res.code === 200) {
          this.headInfoList = res.data;
          this.priceInfoDate = res.data[0]["priceDate"];
        }
      });
    },

    initViewPointList() {
      let  categoryId = this.$route.query.categoryId
      if(!categoryId || isNaN(parseInt(categoryId))) return 
      getViewpoint().then((res) => {
        if (res) {
          let data = res.data.slice(0, 4);
          this.viewPointList = data;
        }
      });
    },

    initDynamicInfo() {
      getMarketDynamic().then((res) => {
        if (res) {
          this.dynamicList = res;
        }
      });
    },

    initCommitInfo() {
      getDailyCommit().then((res) => {
        if (res) {
          this.commitList = res;
        }
      });
    },
    initWeekReport() {
      getReportWeek().then((res) => {
        if (res.code === 200) {
          this.weekReportList = res.data;
        }
      });
    },
    initMonthReport() {
      getReportMonth().then((res) => {
        if (res.code === 200) {
          this.monthReportList = res.data;
        }
      });
    },
    initYearReport() {
      getReportYear().then((res) => {
        if (res.code === 200 ) {
          this.yearReportList = res.data;
        }
      });
    },

    initHandleHeadMouse() {
      let priceContainerDom = document.getElementById(
        "head-carousel-container"
      );
      priceContainerDom.addEventListener("mouseover", () => {
        this.headCarouselPause();
      });
      priceContainerDom.addEventListener("mouseout", () => {
        this.headCarouselScroll();
      });
    },
    headCarouselPause() {
      if (this.headSetdoFun) {
        clearInterval(this.headSetdoFun);
      }
    },
    headCarouselScroll() {
      if(this.headSetdoFun){
        clearInterval(this.headSetdoFun)
      }
      this.headSetdoFun = setInterval(() => {
        this.carouselFirIndex++;
        if (this.carouselFirIndex > this.zhishuList.length) {
          this.carouselFirIndex = 1;
        }
      }, 3000);
    },

    // 跳转注册页
    toRegister() {
      // // const defaultWebSite = "http://www.baiinfo.com/Account/Register?";
      // const  defaultWebSite = "http://meeting.baiinfo.com:8081/Account/Register?"
      // const query = this.routeQuery;
      // // {
      // //   source: 1,
      // //   admLogName: 100099,
      // // };
      // let queryStrList = [];
      // for (const key in query) {
      //   if (Object.hasOwnProperty.call(query, key)) {
      //     queryStrList.push(`${key}=${query[key]}`);
      //   }
      // }
      // let queryStr = queryStrList.join("&");
      // const webStr = defaultWebSite + queryStr;
      // window.open(webStr, "__blank");
      const currentQuery = this.$route.query;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...currentQuery,
          formType: "register",
        },
      });

      // 跳转本页面的 login
      // this.$refs["registerCard"].showCard();
    },
  },
};
</script>
<style lang="scss"  scoped>
.main-container {
  padding: 10px;

  /deep/ .card-module-container {
    /deep/.card-thrid-item {
      .thrid-item-title {
        font-size: 18px;

        font-weight: 400;
        color: #333333;
        padding: 8px 0;
      }

      .card-box {
        height: 285px;
        overflow: hidden;
        width: 100%;
        overflow: hidden;
        border: 1px solid #dcdfe6;
      }
    }
  }
}
.home-container {
  position: relative;
  .home-contain-bottom {
    position: fixed;
    z-index: 5;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4em;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0px 0px 18px 0px rgba(133, 133, 133, 0.15);

    .contain-bottom-item {
      width: 8em;
      height: 2.5em;
      line-height: 2.5em;
      border: 1px solid #2b304d;
      text-align: center;
      background-color: #ffffff;
      color: #2b304d;
      a {
        color: #2b304d;
      }
    }

    .contain-bottom-bg-item {
      background-color: #2b304d;
      color: #ffffff;
    }
  }
  .home-banner {
    // height: 80px;
    height: 220px;
    width: 100%;
    background: url(../assets/home/banner.png);
    background-position: 25% 25%;
    background-size: cover;
    background-repeat: no-repeat;
    transition: all 150ms ease-in-out;
  }
  .sm-home-banner {
    height: 134px;
    width: 100%;
    background: url(../assets/home/smbanner.png);
    background-size: cover;
    background-repeat: no-repeat;
  }

  .carousel-container {
    width: 100%;
    // height: 140px;
    // padding: 20px;
    padding: 10px;
    background: #f5f6f9;

    overflow: hidden;
    .carousel-box {
      // height: 100px;
      height: 64px;
      margin: auto;
      position: relative;
      background: #f5f6f9;
      overflow: hidden;
      .carousel-item {
        position: absolute;
        display: flex;
        flex-flow: column;
        justify-content: space-around;
        width: 180px;
        // width: 170px;
        // height: 100px;
        height: 64px;
        margin-right: 20px;
        padding: 10px;
        background-color: #ffffff;
        opacity: 0;
        transform: translate3d(0, 0, 0);
        transition-property: left, opacity;
        transition: all 3000ms linear;

        .carousel-item-head {
          display: flex;
          justify-content: space-between;

          font-size: 12px;
          font-weight: bold;
          color: #333333;
        }
        .carousel-item-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .main {
            font-size: 20px;

            font-weight: bold;
            color: #000000;
          }

          .aside {
            display: inline-block;
            font-size: 12px;
            min-width: 5rem;
            text-align: center;
            height: 25px;
            line-height: 25px;

            color: #ffffff;
            font-size: 14px;

            font-weight: 500;
          }
        }
        .carousel-sub-title {
          font-size: 12px;

          font-weight: 400;
          color: #999999;
        }
      }
      .trans-item {
        transition: all 3000ms linear;
      }
      .trans-no-item {
        transition: all 0 linear;
      }
      .carousel-normal-item {
        opacity: 1;
      }
      .carousel-hidden-item {
        opacity: 0;
      }
    }
  }

  .card-module-container {
    // width: 1200px;
    width: 100%;
    margin: auto;
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 10px;
    font-size: 14px;
    overflow: hidden;

    .card-half-item {
      width: 100%;
      padding: 10px 0;
      transition: all 250ms ease-in-out;
      .card-box {
        height: 402px;
        overflow: hidden;
        border: 1px solid #dcdfe6;
      }
    }

    /deep/ .card-thrid-item {
      width: 100%;
      transition: all 250ms ease-in-out;
      margin: 0 0 10px;
      &:first-of-type,
      &:last-of-type {
        margin-bottom: 10px;
      }
      .thrid-item-title {
        font-size: 18px;

        font-weight: 400;
        color: #333333;
        padding: 8px 0;
      }

      .card-box {
        // height: 285px;
        height: 324px;
        overflow: hidden;
        width: 100%;
        overflow: hidden;
        border: 1px solid #dcdfe6;
      }
    }

    /deep/ .card-item-head {
      padding-bottom: 13px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      .card-item-head-sub {
        float: right;
        font-size: 14px;
        color: #999999;
        font-weight: 400;
      }
    }

    .card-cover-item {
      padding-top: 0;
      .card-box {
        border-width: 0;
        height: 270px;
        font-size: 12px;
        color: #333333;
        .card-cover-img {
          width: 100%;
          height: 100%;
          background: url(../assets/home/class.png);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
        }
      }
    }
  }

  .card-module-left {
    width: 100%;
    .card-box {
      .item {
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        width: 100%;
        height: 100px;
        padding: 15px 20px;

        .head {
          font-size: 16px;
          height: 1.6rem;
          line-height: 1.6rem;

          font-weight: bold;
          color: #333333;
        }
        .main {
          width: 540px;
          font-size: 14px;
          height: 1.6rem;
          line-height: 1.6rem;

          font-weight: 400;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          /deep/ p {
            text-indent: 0.5rem !important;
            display: inline-block;
            height: 1.5rem;

            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .bottom {
          text-indent: 0.5rem;
          color: #999999;
        }
      }

      .item:nth-of-type(even) {
        background-color: #f8f8f8;
      }
    }
  }
  .card-module-right {
    .card-box {
      .box-head {
        position: relative;
        z-index: 5;
        display: flex;
        justify-content: space-between;
        width: 100%;

        height: 40px;
        line-height: 40px;
        .box-head-item {
          min-width: 25%;
          width: 25%;
          text-align: center;
          padding: 0;
          // padding: 0 20px;
          font-weight: 400;
          color: #333333;
          background-color: #f8f8f8;
        }
      }
    }
  }

  /deep/ .card-module-normal {
    .card-box {
      .normal-item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        padding: 0 10px;
        color: #303133;
        .haschild-content {
          flex-basis: 1;
          flex-grow: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          display: flex;
          align-items: center;

          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .content {
          flex-basis: 1;
          flex-grow: 1;
          // max-width
          // max-width: calc(100% - 7rem);
          // min-width: calc(100% - 7rem);

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .aside {
          height: 1.2rem;
          line-height: 1.2rem;
          min-width: 5rem;
          width: 5rem;
          text-align: right;
          font-size: 14px;
          font-weight: 400;
          color: #909399;
          overflow: hidden;
        }
      }
      .normal-item:nth-of-type(even) {
        background: #f8f8f9;
      }
    }
  }

  .advitise-container {
    // display:flex;
    // justify-content: center;
    // align-items: center;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 20px;
    // height: 120px;
    height: 0;
    margin: 0;
    padding: 0;
    // background-color: #58627f;
    background-color: #ffffff;
    overflow: hidden;
    transition: all 150ms ease-in-out;
    cursor: pointer;
    img {
      width: 100%;
      height: 120px;
      object-fit: contain;
    }
  }
}

@media (min-width: 1024px) {
  .carousel-container {
    .carousel-box {
      width: 100%;
    }
  }
}
@media (min-width: 1280px) {
  .home-container {
    .home-banner {
      height: 220px;
    }
    .carousel-container {
      .carousel-box {
        width: 1200px;
      }
    }

    .carousel-container {
      .carousel-box {
        width: 1200px;
      }
    }

    .advitise-container {
      height: 120px;
      margin: 20px auto;
    }

    .card-module-container {
      width: 1200px;
      padding: 10px 0;

      .card-half-item {
        min-width: 590px;
        width: 590px;
        padding: 0;
      }
      /deep/ .card-thrid-item {
        min-width: 386px;
        width: 386px;
      }

      .card-module-left {
        .card-box {
          .box-head {
            .box-head-item {
              padding: 15px 20px;
            }
          }
        }
      }
      .card-module-right {
        .card-box {
          .box-head {
            .box-head-item {
              text-align: left;
              // padding: 0 20px;
              padding-left: 20px;
            }
          }
        }
      }
      .card-cover-item {
        padding-top: 10px;
      }
    }
    /deep/ .card-module-normal {
      .card-box {
        .normal-item {
          .aside {
            min-width: 6rem;
            width: 6rem;
          }
        }
      }
    }

    .main-container {
      padding: 0;
      .card-module-container {
        width: 1200px;
        padding: 10px 0;

        /deep/ .card-thrid-item {
          min-width: 386px;
          width: 386px;
        }
      }
    }
  }
}
</style>
